import * as React from 'react';
import { LinkAvailableText } from '@/components/element/LinkAvailableText';

type Props = {
  content: string;
};
export const SimpleTextFormat = ({ content }: Props) => {
  return (
    <>
      {content.split(/(\n)/g).map((t, i) => (
        <React.Fragment key={`${crypto.randomUUID()}`}>{t === '\n' ? <br /> : t}</React.Fragment>
      ))}
    </>
  );
};

export const SimpleTextFormatWithLink = ({ content }: Props) => {
  return (
    <>
      {content.split(/(\n)/g).map((t, i) => (
        <React.Fragment key={`${crypto.randomUUID()}`}>
          {t === '\n' ?
            <br /> :
            <LinkAvailableText content={t} />}</React.Fragment>
      ))}
    </>
  );
};
